import { GasThreadInformation, GasThreadSectors } from '@gasbi/shared/web/Gds';
import { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

export const gdsGasThreadDetailsRoutes: RouteObject[] = [
  {
    element: <GasThreadInformation />,
    index: true,
  },
  {
    path: Pages.SECTORS,
    element: <GasThreadSectors />,
  },
];
